// extracted by mini-css-extract-plugin
module.exports = {"info":"info_info__3VYon","icon":"info_icon__33e_2"};